module.exports = __webpack_public_path__ + "img/744.50e6f6cc.jpg";